export default {
  'apply.policy.agreeTip': '我已阅读以上数据集隐私协议内容知晓并确认相关内容',
  'apply.policy.agree': '请勾选同意选项',
  'apply.form.label.name': '姓名',
  'apply.form.label.email': '邮箱',
  'apply.form.label.org': '组织',
  'apply.form.label.profession': '职业',
  'apply.form.label.purpose': '数据集用途',
  'apply.form.label.desc': '用途详细描述',
  'apply.form.label.policy': '提交此申请即代表同意',
  'apply.form.label.policy.service': '平台用户服务协议',
  'apply.form.label.policy.privacy': '隐私政策',
  'apply.form.placeholder.email': '请填写您的企业邮箱，用于接收申请结果',
  'apply.form.placeholder.name': '请输入真实姓名',
  'apply.form.placeholder.org': '请输入组织名称',
  'apply.form.placeholder.profession': '请输入您的职业身份',
  'apply.form.placeholder.purpose': '请输入真实姓名',
  'apply.form.placeholder.desc': '请详细描述您使用该数据集的用途',
  'apply.form.rule.email': '请填写有效的邮箱地址',
  'apply.form.required.email': '请输入邮箱',
  'apply.form.required.name': '请输入真实姓名',
  'apply.form.required.org': '请输入组织名称',
  'apply.form.required.profession': '请输入职业身份',
  'apply.form.required.purpose': '请至少选择一项',
  'apply.form.cancel': '取消',
  'apply.button.popover': '申请结果将在审批后邮件通知，请耐心等待',
  'apply.form.purpose.1': '教学与学习',
  'apply.form.purpose.2': '商业用途',
  'apply.form.purpose.3': '科研与论文发表',
  'apply.form.purpose.4': '比赛',
  'apply.form.purpose.5': '其他',
  'apply.form.res.front': '审批结果及下载链接将发送至您的邮箱',
  'apply.form.res.end': '请耐心等待',
  'apply.form.second': '秒',
  'apply.form.second.left': '剩余',
  'apply.form.next': '下一步',
  'apply.form.apply': '申请',
  'apply.form.submit': '申请',
  'apply.form.datasetAuth': '数据集授权',
  'apply.button.applyForDownload': '申请下载',
  'apply.form.submit.error': '出错了，请稍后再试！',
  'apply.form.submit.success': '提交成功',
  'apply.form.submit.success.confirm': '知道了',
  'cli.step.tip1': '欢迎加入 {platformName}, 登录后即可添加密钥以使用 CLI/SDK 下载',
  'cli.step1.signin': '登录',
  'cli.step1.signup': '注册',
  'cli.step.tip2': '请先{tip2Link}，即可使用 CLI/SDK 下载方法',
  'cli.step.tip2.link': '填写用户信息',
  'cli.step.tip2.waiting': '申请审核中，通过后即可用CLI/SDK下载',
  'cli.step.tip.aksk1': '暂无密钥，请前往密钥管理添加密钥',
  'cli.step.tip.aksk2': '为使用 SDK / CLI 访问平台时通过身份校验，请先添加 Access Key ID 和 Secret Access Key。',
  'cli.step.tip.aksk3': '为通过身份校验，可在 {keyManage} 中查看你的 Access Key ID 和 Secret Access Key ',
  'cli.step.keyManage': '密钥管理',
  'cli.step.aksk.add': ' 添加密钥',
  'cli.step.aksk.tip': '不再提醒',
  'cli.download': '下载',
  'cli.annotation.install': '安装',
  'cli.annotation.upgrade': '版本升级',
  'cli.annotation.login': '进行登录，输入对应的AK/SK',
  'cli.annotation.info': '数据集信息查看',
  'cli.annotation.ls': '数据集文件列表查看',
  'cli.annotation.get': '数据集下载',
  'cli.annotation.download': '数据集文件下载',
  'cli.firstDownload.tip': '首次下载？点击下载完成信息填报',
  'cli.annotation.info.list': '数据集信息及文件列表查看',
  'cli.md.tip1': '进行登录，输入对应的AK/SK，可在{tip1Link}添加AK/SK',
  'cli.md.tip1.link': '个人中心',
  'cli.md.tip2': '进行登录，输入对应的AK/SK。可在{tip2Link}查看AK/SK',
  'cli.md.tip2.link': '个人中心'
};
